export default __webpack_public_path__ + "static/media/document.a03668c6.svg";